import React, { useEffect, useRef, useState } from 'react';
import styles from './index.module.scss';
import close from '../../../assets/images/close.svg';
import { MOCK_PAY_DAY_OFFERS as data } from '../../../api/mock.data.js';
import starAssets from '../../StarPage/imagePage';
import useOnClickOutside from '../../../hooks/useOnClickOutside.js';
import paydayAssets from '../PayDay/payDayImages';
import {
  callFlutterExternalLinkHandler,
  callFlutterHandler,
} from '../../../utils/flutterBridge.js';
import { ctLogV2 } from '../../../utils/cleverTapLogger.utils.js';
import { useIdHash } from '../../../hooks/custom.hooks.js';
import ShimmerSkeleton from '../PayDay/Shimmer/index.jsx';
import { useSelector } from 'react-redux';

function GateWayDeals() {
  const { custId: cid } = useIdHash();
  const [activeTab, setActiveTab] = useState('Online');
  const [activeIndex, setActiveIndex] = useState(null);
  const fqRef = useRef(null);
  const faqScrollRef = useRef(null); // for scrolling
  // const [isLoaded, setIsLoaded] = useState(false);
  const imageLoading = useSelector(
    ({ appReducer }) => appReducer.imagesLoading,
  );

  const handleCategoryClick = (item) => {
    handleEventCall(item);
    faqScrollRef.current?.scrollIntoView({
      behavior: 'smooth',
      block: 'start',
    });
  };

  useOnClickOutside(fqRef, () => {
    setActiveIndex(null);
  });

  useEffect(() => {
    if (cid) {
      logPaydayEvent({
        eventName: 'AppWebpageViewed',
        customerId: cid,
      });
    }
  }, [cid]);

  const logPaydayEvent = ({
    eventName,
    customerId,
    bannerName,
    bannerPosition,
    type,
  }) => {
    ctLogV2({
      eventName: eventName,
      customerId: customerId,
      extraData: {
        source: 'Getaway Deals',
        ...(type && { type }),
        ...(bannerPosition && {
          banner_position: bannerPosition,
        }),
        ...(bannerName && { banner_name: bannerName }),
      },
    });
  };

  const stepData = {
    Online: [
      {
        icon: paydayAssets?.online?.onlinestep1,
        title: 'Head to any partnered brand website.',
        eventName: 'AppWebpageElementClicked',
        type: 'HowtoUseRewards',
        name: 'Online',
      },
      {
        icon: paydayAssets?.online?.ticket,
        title: 'Book your tickets.',
        eventName: 'AppWebpageElementClicked',
        type: 'HowtoUseRewards',
        name: 'Online',
      },
      {
        icon: paydayAssets?.online?.onlinestep3,
        title:
          'At the checkout, select Pay with Rewards to use your points and unlock extra discounts.',
        eventName: 'AppWebpageElementClicked',
        type: 'HowtoUseRewards',
        name: 'Online',
      },
    ],
    Offline: [],
  };
  const steps = stepData[activeTab];

  const twidIntro = [
    {
      img: paydayAssets?.userInfo?.usercount,
      title: '10M+',
      sub_title: 'users',
    },
    {
      img: paydayAssets?.userInfo?.rewardSaved,
      title: '₹100Cr+',
      sub_title: 'Rewards Saved',
    },
    {
      img: paydayAssets?.userInfo?.rated,
      title: '4.8★',
      sub_title: 'Rated App',
    },
  ];

  const faqList = [
    {
      question: 'What is Long Weekend Bonanza?',
      answer:
        'Long Weekend Bonanza are special offers that help you save more on your travel plan for upcoming long weekends.',
      eventName: 'AppWebpageElementClicked',
      type: 'FAQ',
      name: 'What is Long Weekend Bonanza?',
    },
    /*{
      question: 'How long are Long Weekend Bonanza deals valid?',
      answer:
        'The campaign runs for 6 days, between 9th-14th January 2026',
      eventName: 'AppWebpageElementClicked',
      type: 'FAQ',
      name: 'The campaign runs for 6 days, between 9th-14th January 2026',
    },*/
    {
      question: 'Where can I use these deals?',
      answer:
        'You can book your travel tickets on ixigo, Confirmtkt, redBus, AbhiBus, EaseMyTrip',
      eventName: 'AppWebpageElementClicked',
      type: 'FAQ',
      name: 'Where can I use these deals?',
    },
    {
      question: 'How do I redeem my rewards?',
      answer: [
        '<b>Online:</b> Select your merchant → Add to cart → Choose Pay with Rewards (TWID UPI) at checkout.',
      ],
      eventName: 'AppWebpageElementClicked',
      type: 'FAQ',
      name: 'How do I redeem my rewards?',
      renderFormat: 'list',
    },
    {
      question: 'Can I combine Long Weekend Bonanza deals?',
      answer:
        'Yes, in many cases you can combine Weekend Bonanza Deals with bank/card offers for extra savings. (T&Cs apply).',
      eventName: 'AppWebpageElementClicked',
      type: 'FAQ',
      name: 'Can I combine Long Weekend Bonanza deals?',
    },
  ];

  const toggleAccordion = (index) => {
    setActiveIndex((prevIndex) => (prevIndex === index ? null : index));
  };

  const handleEventCall = (item) => {
    logPaydayEvent({
      eventName: item?.eventName,
      customerId: cid,
      type: item?.type,
      bannerPosition: item?.position,
      bannerName: item?.name,
    });
    if (item?.redirectUrl) {
      if (!item?.inApp) {
        callFlutterExternalLinkHandler('openLinkExternal', {
          url: item?.redirectUrl,
        });
      } else if (item?.inApp) {
        callFlutterHandler('backButton');
      }
    }
  };
  if (imageLoading) {
    return <ShimmerSkeleton />;
  }

  return (
    <div className={styles.pageContainer}>
      <div className={styles.headerSection}>
        <div className={styles.heading}>Offer Details</div>
        <img
          src={close}
          alt="close"
          style={{ cursor: 'pointer' }}
          onClick={() => {
            callFlutterHandler('backButton');
          }}
        />
      </div>
      <div className={styles.contentSection}>
        {/* banner image  done  */}
        <div className={styles.banner}>
          <img src={data?.gateway_banner?.imageUrl} alt="Pay Day Banner" />
        </div>
        {/* categories done */}
        <div className={styles.categoriesSection}>
          <div className={styles.heading}>
            Save up to ₹1,000 on your upcoming Long Weekends (14-18 Jan | 24-26
            Jan)
          </div>
          <div className={styles.subHeading}>
            Your 2 Long Weekends, Rewarded
          </div>
          <div className={styles.img}>
            {data?.gateway_categories?.map((category, index) => (
              <div
                key={index}
                className={styles.category}
                onClick={() => handleCategoryClick(category)}
              >
                <img src={category?.imageUrl} alt={`Category ${index + 1}`} />
              </div>
            ))}
          </div>
        </div>

        {/* verified */}
        <div className={styles.verifiedSection}>
          {data?.verifiedBy?.map((item, index) => (
            <div key={index} className={styles.verified}>
              <img src={item?.logoUrl} alt={`verified ${index + 1}`} />
            </div>
          ))}
        </div>

        {/* How to redeem star */}
        <div ref={faqScrollRef} className={styles.redeemContent}>
          <div className={styles.title}>How to use Rewards</div>
          <div className={styles.tabs} style={{ display: 'none' }}>
            {['', ''].map((tab) => (
              <button
                key={tab}
                className={`${styles.tab} ${activeTab === tab ? styles.active : ''}`}
                onClick={() => {
                  setActiveTab(tab);
                  handleEventCall(tab);
                }}
              >
                {tab}
              </button>
            ))}
          </div>
          <div className={styles.steps}>
            {steps?.map((step, index) => (
              <div key={index} className={styles.step}>
                <div className={styles.iconWrapper}>
                  <img src={step.icon} alt={`step-${index + 1}`} />
                  {index !== steps.length - 1 && (
                    <div className={styles.dottedLine} />
                  )}
                </div>
                <div className={styles.text}>
                  <div className={styles.stepNumber}>STEP {index + 1}</div>
                  <div className={styles.stepTitle}>{step.title}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
        {/* star intro */}
        <div
          className={styles.introContainer}
          style={{
            backgroundImage: `url(${paydayAssets?.metric})`,
            backgroundSize: 'cover',
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'center',
          }}
        >
          <div className={styles.AboutStarContainer}>
            {twidIntro?.map((elem, index) => {
              const isOdd = index % 2 !== 0;
              return (
                <div
                  key={index}
                  className={`${styles.renderCard} ${isOdd ? styles.oddCard : ''}`}
                >
                  <img src={elem.img} alt={elem.title} />
                  <div>{elem?.title}</div>
                  <div>{elem?.sub_title}</div>
                </div>
              );
            })}
          </div>
        </div>

        {/*  Frequent Asked question */}
        <div className={styles.fqContainer}>
          <div className={styles.heading}>Got Questions?</div>
          <div ref={fqRef} className={styles.listContainer}>
            {faqList.map((item, index) => (
              <div key={index} className={styles.section}>
                <div
                  onClick={() => {
                    toggleAccordion(index);
                    handleEventCall(item);
                  }}
                  className={styles.question}
                >
                  <div style={{ width: '85%' }}>{item.question}</div>
                  <img
                    src={starAssets.down}
                    alt="down_img"
                    style={{
                      transform:
                        activeIndex === index
                          ? 'rotate(180deg)'
                          : 'rotate(0deg)',
                      transition: 'transform 0.3s ease',
                    }}
                  />
                </div>
                {activeIndex === index &&
                  (item?.renderFormat === 'list' ? (
                    <ul className={styles.answerList}>
                      {item.answer.map((answerStr, i) => (
                        <li
                          className={styles.answerSpace}
                          key={i}
                          dangerouslySetInnerHTML={{ __html: answerStr }}
                        />
                      ))}
                    </ul>
                  ) : (
                    <div className={styles.answer} style={{ width: '100%' }}>
                      {item.answer}
                    </div>
                  ))}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default GateWayDeals;
